export default __webpack_public_path__ + "media/images/elephant-fren-ccb274b442d70ed8b96430c9371f8eb3.png";